// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck {
  width: 16px;
  height: 16px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-0);
  background: var(--bg-alt);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition:
    background 100ms,
    border-color 100ms;
}

.ck.on {
  background: var(--signal);
  border-color: var(--signal);
  color: white;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  line-height: 1;
}

.ck.on::after {
  content: '✓';
}

.ck.indeterminate {
  background: var(--signal);
  border-color: var(--signal);
}

.ck.indeterminate::after {
  content: '−';
  color: white;
  font-family: var(--mono);
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd;;sBAEoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB","sourcesContent":[".ck {\n  width: 16px;\n  height: 16px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-0);\n  background: var(--bg-alt);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition:\n    background 100ms,\n    border-color 100ms;\n}\n\n.ck.on {\n  background: var(--signal);\n  border-color: var(--signal);\n  color: white;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  line-height: 1;\n}\n\n.ck.on::after {\n  content: '✓';\n}\n\n.ck.indeterminate {\n  background: var(--signal);\n  border-color: var(--signal);\n}\n\n.ck.indeterminate::after {\n  content: '−';\n  color: white;\n  font-family: var(--mono);\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
